import { getCamelOrSnakeCase } from '@/helpers';

export default function inArrayFilter(haystack, itemKey) {
    return (item) => {
        return haystack.includes(getCamelOrSnakeCase(item, itemKey));
    };
}
